/**
 * Routing layer entry point.
 *
 * Adding another liquidity source is: write a file in ./providers implementing
 * `QuoteProvider`, add its id to KNOWN_PROVIDER_IDS, and register it below. Which of
 * the registered sources actually run is controlled by config, not by this file.
 */
import { registerProvider } from './registry'
import { isProviderEnabled } from './config'
import { openOceanProvider } from './providers/openocean'
import { zeroExProvider } from './providers/zeroex'
import { oneInchProvider } from './providers/oneinch'

const ALL_PROVIDERS = [openOceanProvider, zeroExProvider, oneInchProvider]

// Registered only when enabled, so an operator can turn a source on or off without a
// rebuild of the routing logic. Providers additionally self-report as unconfigured
// when they are missing credentials - see QuoteProvider.isConfigured.
ALL_PROVIDERS.filter((provider) => isProviderEnabled(provider.id)).forEach(registerProvider)

export * from './types'
export * from './registry'
export { revenueConfig, MAX_FEE_BPS, parseRevenueConfig } from './revenue'
export { enabledProviderIds, parseEnabledProviders, KNOWN_PROVIDER_IDS } from './config'
export { hasQuoteProxy } from './http'
